export var hasExtraItems = function hasExtraItems(array, shouldCompareThree) {
  var numberToCompare = shouldCompareThree ? 3 : 5;
  return array.length > numberToCompare;
};